import template from "./account-activity-interest-earnings-payment-details.html"

ko.components.register('account-activity-interest-earnings-payment-details', {
    template: template,
    viewModel: {
        createViewModel: function (params, componentInfo, widgetInfo) {
            return new PaymentDetails(params, widgetInfo);
        }
    }
});

export class PaymentDetails {
    constructor(params, widgetInfo) {
        let model = params.model;

        this.total = model.ResponsibilityAmount;
    }
}